import { handlePagingAll } from "../api/APIUtilities";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import moment from "moment";

export const fetchCircuitTokenData = async (authContext) => {
  try {
    let gameSystemsData = await handlePagingAll("/gamesystems", {
      inclSystem: true,
    });

    const gameSystemsDict = {};
    gameSystemsData.forEach(system => {
      gameSystemsDict[system.id] = system;
    });

    let queryParams = {
      public: true,
      active: true,
      sortKey: "name",
      "expand[]": ["gameSystem", "gameStore"],
    };
    
    if (getEnvironmentVariable("SINGLE_GAME_SYSTEM")) {
      queryParams.gameSystemId = getEnvironmentVariable("SINGLE_GAME_SYSTEM");
    } else if (getEnvironmentVariable("SINGLE_GAME_MANUFACTURER")) {
      queryParams.gameSystemManufacturer = getEnvironmentVariable("SINGLE_GAME_MANUFACTURER");
    }

    let queryParamsTokens = {
      limit: 500,
      userId: authContext?.authState?.identity?.userId,
      "expand[]": ["league", "event"],
    };

    if (getEnvironmentVariable("SINGLE_GAME_SYSTEM")) {
      queryParamsTokens.gameSystemId = getEnvironmentVariable("SINGLE_GAME_SYSTEM");
    } else if (getEnvironmentVariable("SINGLE_GAME_MANUFACTURER")) {
      queryParamsTokens.gameSystemManufacturer = getEnvironmentVariable("SINGLE_GAME_MANUFACTURER");
    }

    const tokenData = await handlePagingAll("/leaguetokens", queryParamsTokens);

    if (tokenData?.length) {
      tokenData.forEach((token) => {
        if (token.league && token.league.gameSystemId) {
          token.league.gameSystem = gameSystemsDict[token.league.gameSystemId];
        }
      });

      tokenData.sort((a, b) => {
        const dateA = moment(a.created_at);
        const dateB = moment(b.created_at);
        return dateB.diff(dateA);
      });
    }

    return tokenData || [];
  } catch (error) {
    console.error("Error fetching circuit token data:", error);
    return [];
  }
}; 
// Maps a circuit token status to an MUI palette color for status chips
export const getTokenStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case "active":
      return "success";
    case "pending":
      return "warning";
    case "used":
      return "info";
    default:
      return "error";
  }
};
